export const VOICE_TEXT = {
  micLabel: "Mic:",
  defaultMic: "Default microphone",

  typingHint: "Type your answer below",
  startingVoice: "Starting voice…",
  recording: "Recording…",
  speaking: "Speaking…",
  ready: "Ready",

  initPlaceholder: "Initializing…",
  recordPlaceholder: "Recording…",
  idlePlaceholder: "Use Start recording to begin",

  tooShort: "We need a bit more information. Could you elaborate?",

  playQuestion: "Play question",
  speakingEllipsis: "Speaking…",
  start: "Start recording",
  stop: "Stop",
  clear: "Clear",
  submit: "Submit",
} as const;

export const VOICE_ARIA = {
  micSelectLabel: "Select microphone device",
  statusText: "Voice status",
  answerArea: "Transcribed answer",
} as const;
